import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// Element Plus 官方深色模式变量（html.dark 下生效，覆盖全部组件：
// 表格、对话框、下拉面板、分页、标签、输入框等，避免深浅色切换遗漏）
import 'element-plus/theme-chalk/dark/css-vars.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import en from 'element-plus/dist/locale/en.mjs'
import { useI18n } from 'vue-i18n'

export default {
  install(app) {
    // 注册Element Plus
    app.use(ElementPlus, {
      locale: getLocale(),
      size: 'default',
      zIndex: 2000
    })

    // 注册所有图标
    for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
      app.component(key, component)
    }

    // 添加全局配置
    app.config.globalProperties.$ELEMENT = {
      size: 'default',
      zIndex: 2000
    }
  }
}

// 获取语言配置
function getLocale() {
  const language = localStorage.getItem('language') || navigator.language || 'zh-CN'

  if (language.startsWith('zh')) {
    return zhCn
  } else {
    return en
  }
}

// 设置主题
// 深色模式的组件变量由 element-plus/theme-chalk/dark/css-vars.css 统一提供，
// 这里只切换 html.dark 类，不再内联注入变量（旧变量表与官方文件存在错位，会干扰组件渲染）
export function setTheme(themeMode) {
  const isDark = themeMode === 'dark'
  const html = document.documentElement

  // 设置主题模式
  html.classList.toggle('dark', isDark)
  localStorage.setItem('theme', themeMode)
}

// 初始化主题
export function initTheme() {
  const savedTheme = localStorage.getItem('theme')
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches

  if (savedTheme) {
    setTheme(savedTheme)
  } else if (prefersDark) {
    setTheme('dark')
  } else {
    setTheme('light')
  }
}

// 获取主题配置
export function getThemeConfig() {
  return {
    light: {
      primary: '#409eff',
      success: '#67c23a',
      warning: '#e6a23c',
      danger: '#f56c6c',
      info: '#909399'
    },
    dark: {
      primary: '#409eff',
      success: '#67c23a',
      warning: '#e6a23c',
      danger: '#f56c6c',
      info: '#909399'
    }
  }
}

// 响应式断点配置
export const breakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400
}